requestAnimationFrame(() => {
  themeBase.onDOMContentLoadedTrigger(() => {
    scriptController.onStyleReady(() => {
      scriptController.executeWhenScriptLoaded(['slider-component.js'], () => {
        if (!customElements.get('slideshow-component')) {
          class SlideshowComponent extends SliderComponent {
            constructor() {
              super();
            }

            connectedCallback() {
              super.connectedCallback();
              this.initializeSlideshow();
            }

            initializeSlideshow() {
              this.ANIMATIONS_DURATION = 700;
              this.sliderControlWrapper = this.querySelector('.slider-buttons');
              this.enableSliderLooping = true;
              this.pageX = 0;
              this.pageY = 0;
              this.pageYOffset = 0;
              this.scrollDuration = this.ANIMATIONS_DURATION * this.dataset.sliderAnimationsSpeedRatio;

              if (!this.sliderControlWrapper) return;

              this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');

              if (this.sliderItemsToShow.length > 0) this.currentPage = 0;

              this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
              this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

              this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
              this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));

              const onFirstPreloadImages = () => {
                this.preloadImages();
                removeFirstPreloadImagesListeners();
              };
              const removeFirstPreloadImagesListeners = () => {
                this.slider.removeEventListener('mouseenter', onFirstPreloadImages);
                window.removeEventListener('load', onFirstPreloadImages);
              };

              this.slider.addEventListener('mouseenter', onFirstPreloadImages);
              window.addEventListener('load', onFirstPreloadImages);

              if (this.announcementBarSlider) {
                this.announcementBarArrowButtonWasClicked = false;


                this.reducedMotion = {
                  matches: false
                };

                [this.prevButton, this.nextButton].forEach((button) => {
                  button.addEventListener(
                    'click',
                    () => {
                      this.announcementBarArrowButtonWasClicked = true;
                    }, {
                      once: true
                    }
                  );
                });
              }

              if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();

              const stickyHeader = window.themeHeader?.getWrapper?.() || document.querySelector('.header-sections-wrapper');

              if (stickyHeader) stickyHeader.slideshowComponent = this;
            }



            initPages() {
              this.initializeAnimations = this.dataset.enableSliderAnimations === 'true' && !isTouchCapable() && themeBase.isDesktop;

              if (this.initializeAnimations) this.classList.add('slideshow--animation-effects');
              else this.classList.remove('slideshow--animation-effects');
              super.initPages();
            }

            update() {
              super.update();
              this.dynamicProcessing();
              this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
              this.prevButton.removeAttribute('disabled');

              if (this.sliderControlButtons.length) {
                this.sliderControlButtons.forEach((link) => {
                  link.classList.remove('slider-counter__link--active');
                  link.removeAttribute('aria-current');
                });

                this.sliderControlButtons[this.currentPage].classList.add('slider-counter__link--active');
                this.sliderControlButtons[this.currentPage].setAttribute('aria-current', true);
              }
            }

            setAutoPlay() {
              this.autoplaySpeed = this.slider.dataset.speed * 1000;
              this.addEventListener('mouseover', this.focusInHandling.bind(this));
              this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
              this.addEventListener('focusin', this.focusInHandling.bind(this));
              this.addEventListener('focusout', this.focusOutHandling.bind(this));

              if (this.querySelector('.slideshow__autoplay')) {
                this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
                this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
                this.autoplayButtonIsSetToPlay = true;
                this.play();
              } else {
                this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ?
                  this.pause() :
                  this.play();
              }
            }



            onButtonClick(event, button) {
              if (this.isScrolling) return;

              this.slider.classList.add('slideshow--interacted');
              super.onButtonClick(event, button);
              this.wasClicked = true;
              button = button || event.currentTarget.name;

              const isFirstSlide = this.currentPage === 0;
              const isLastSlide = this.currentPage === this.sliderItemsToShow.length - 1;

              if (!isFirstSlide && !isLastSlide) {
                this.applyAnimationToAnnouncementBar(button);
                return;
              }

              if (this.initializeAnimations) {
                this.loop(button, isFirstSlide, isLastSlide);
              } else {
                if (isFirstSlide && button === 'previous') {
                  this.slideScrollPosition = (this.sliderItemsToShow.length - 1) * this.sliderItemOffset;
                } else if (isLastSlide && button === 'next') {
                  this.slideScrollPosition = 0;
                }

                this.setSlidePosition(this.slideScrollPosition);
              }

              this.applyAnimationToAnnouncementBar(button);
            }

            loop(buttonName, isFirstSlide, isLastSlide) {
              if (isFirstSlide && buttonName === 'previous') {
                this.slider.classList.add('slider--infinite-to-last');
                setLogicalScrollLeft(this.slider, (this.sliderItemsToShow.length - 1) * this.sliderFirstItemNode.clientWidth);
                this.slideScrollPosition =
                  (this.sliderItemsToShow.length - 2) * this.sliderFirstItemNode.clientWidth;
                this.setSlidePosition(this.slideScrollPosition, () => {
                  setLogicalScrollLeft(this.slider, (this.sliderItemsToShow.length - 1) * this.sliderFirstItemNode.clientWidth);
                  this.slider.classList.remove('slider--infinite-to-last');
                });
              } else if (isLastSlide && buttonName === 'next') {
                this.slider.classList.add('slider--infinite-to-first');
                setLogicalScrollLeft(this.slider, 0);
                this.slideScrollPosition = this.sliderFirstItemNode.clientWidth;
                this.setSlidePosition(this.slideScrollPosition, () => {
                  setLogicalScrollLeft(this.slider, 0);
                  this.slider.classList.remove('slider--infinite-to-first');
                });
              }
            }

            scrollToWithCallback(element, position, callback) {
              this.isScrolling = true;
              const self = this;

              element.addEventListener('scroll', function onScroll() {

                if (Math.abs(getLogicalScrollLeft(element) - position) <= 1) {
                  requestAnimationFrame(() => {
                    element.removeEventListener('scroll', onScroll);
                    self.isScrolling = false;
                    callback?.();
                  });
                };
              });
              logicalScrollTo(element, {
                left: position,
                behavior: 'smooth'
              });
            }

            setSlidePosition(position, complete) {
              if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
              this.setPositionTimeout = setTimeout(() => {
                this.scrollToWithCallback(this.slider, position, complete);
              }, this.announcerBarAnimationDelay);
            }

            autoPlayToggle() {
              this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
              this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
              this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
            }

            focusOutHandling(event) {
              if (this.sliderAutoplayButton) {
                const focusedOnAutoplayButton =
                  event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
                if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
                this.play();
              } else if (
                !this.reducedMotion.matches &&
                !this.announcementBarArrowButtonWasClicked
              ) {
                this.play();
              }
            }

            focusInHandling(event) {
              if (this.sliderAutoplayButton) {
                const focusedOnAutoplayButton =
                  event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
                if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
                  this.play();
                } else if (this.autoplayButtonIsSetToPlay) {
                  this.pause();
                }
              } else if (this.announcementBarSlider.contains(event.target)) {
                this.pause();
              }
            }

            play() {
              this.slider.setAttribute('aria-live', 'off');
              clearInterval(this.autoplay);
              this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
            }

            pause() {
              this.slider.setAttribute('aria-live', 'polite');
              clearInterval(this.autoplay);
            }

            togglePlayButtonState(pauseAutoplay) {
              if (pauseAutoplay) {
                this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
                this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
              } else {
                this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
                this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
              }
            }

            autoRotateSlides() {
              this.onButtonClick(null, 'next');
            }

            dynamicProcessing(preloadImages) {
              this.setSlideVisibility();

              if (preloadImages) this.preloadImages();
              if (!this.initializeAnimations) {
                this.clearAnimations();
                return;
              }

              if (this.dataset.enableMediaAnimation === 'true') {
                this.setSlideMediaAnimation();
                this.setSlideAdditionalMediaAnimation();
              }

              this.setSlideBannerCSSAnimation();
              this.setSlideContentCSSAnimation();
              this.setSlideBoxAnimation();
              this.setSlideContentElementsCSSAnimation();
              this.hasAnimationStates = true;
            }

            clearAnimations() {
              if (!this.hasAnimationStates) return;

              this.slider.querySelectorAll('*').forEach(element => {
                element.removeAttribute('style');
                element.classList.remove('banner--animate', 'slideshow__content--animate', 'slideshow__content-element--animate');
              });

              this.hasAnimationStates = false;
            }

            setSlideVisibility(event) {
              this.sliderItemsToShow.forEach((item, index) => {
                const linkElements = item.querySelectorAll('a');
                if (index === this.currentPage) {
                  if (linkElements.length)
                    linkElements.forEach((button) => {
                      button.removeAttribute('tabindex');
                    });
                  item.setAttribute('data-hidden-slide', 'false');
                  item.removeAttribute('tabindex');
                } else {
                  if (linkElements.length)
                    linkElements.forEach((button) => {
                      button.setAttribute('tabindex', '-1');
                    });
                  item.setAttribute('data-hidden-slide', 'true');
                  item.setAttribute('tabindex', '-1');
                }
              });
              this.wasClicked = false;
            }

            setSlideMediaAnimation() {
              const TRANSLATE_OFFSET = 70;
              const SCALE_SIZE = 0.2;
              const OPACITY_RANGE = 0.7;
              const BLUR_SIZE = 20;

              this.sliderItemsMedia.forEach((item, index) => {
                if (!item) return;

                const ratioSign = Math.sign(this.slidePositionRatio[index]);
                const ratioAbs = Math.abs(this.slidePositionRatio[index]);
                const translate = TRANSLATE_OFFSET * timingFunctions.easeOutCubic(ratioAbs) * ratioSign;
                const scale = 1 - SCALE_SIZE * timingFunctions.easeInOutQuad(ratioAbs);
                const opacity = 1 - OPACITY_RANGE * timingFunctions.easeInOutCubic(ratioAbs);
                const blur = BLUR_SIZE * timingFunctions.easeInOutQuad(ratioAbs);

                item.style.transform = `translateX(${translate / 10}rem) scale(${scale})`;
                item.style.opacity = opacity;
                item.style.filter = `blur(${blur}px)`;
              });
            }

            setSlideAdditionalMediaAnimation() {
              const TRANSLATE_OFFSET = 100;
              const SCALE_SIZE = 0.5;
              const INDEX_SPREAD_FACTOR = 2;

              const calculateIndexSpread = index => {
                if (index === 0) return 1;
                return index * INDEX_SPREAD_FACTOR;
              };

              this.sliderItemsAdditionalMedia.forEach((contentElements, contentIndex) => {
                if (!contentElements) return;

                const ratioSign = Math.sign(this.slidePositionRatio[contentIndex]);
                const ratioAbs = Math.abs(this.slidePositionRatio[contentIndex]);

                contentElements.forEach((item, index) => {
                  const translate = TRANSLATE_OFFSET * timingFunctions.easeInOutQuad(ratioAbs) * ratioSign * calculateIndexSpread(index);
                  const scale = 1 - SCALE_SIZE * timingFunctions.easeInOutQuad(ratioAbs);

                  item.style.transform = `translateX(${translate}%) scale(${scale})`;
                });
              });
            }

            setSlideBannerCSSAnimation() {
              const START_RATIO_RANGE = 0.6;

              this.sliderItemsBanner.forEach((item, index) => {
                if (!item) return;

                if (this.slidePositionRatio[index] > START_RATIO_RANGE * -1 && this.slidePositionRatio[index] < START_RATIO_RANGE) {
                  item.classList.add('banner--animate');
                } else if (this.slidePositionRatio[index] === 1 || this.slidePositionRatio[index] === -1) {
                  item.classList.remove('banner--animate');

                  if (this.currentPage !== 0) this.slider.classList.remove('slideshow--first-load');
                }
              });
            }

            setSlideContentCSSAnimation() {
              const START_RATIO_RANGE = 0.6;

              this.sliderItemsContent.forEach((item, index) => {
                if (!item) return;

                if (this.slidePositionRatio[index] > START_RATIO_RANGE * -1 && this.slidePositionRatio[index] < START_RATIO_RANGE) {
                  item.classList.add('slideshow__content--animate');
                } else if (this.slidePositionRatio[index] === 1 || this.slidePositionRatio[index] === -1) {
                  item.classList.remove('slideshow__content--animate');
                }
              });
            }

            setSlideBoxAnimation() {
              const TRANSLATE_OFFSET = 70;
              const OPACITY_RANGE = 0.5;

              this.sliderItemsBox.forEach((item, index) => {
                if (!item) return;

                const ratioSign = Math.sign(this.slidePositionRatio[index]);
                const ratioAbs = Math.abs(this.slidePositionRatio[index]);
                const translate = TRANSLATE_OFFSET * timingFunctions.easeInOutQuad(ratioAbs) * ratioSign;
                const opacity = 1 - OPACITY_RANGE * timingFunctions.easeInOutQuad(ratioAbs);

                item.style.transform = `translateX(${translate / 10}rem)`;
                item.style.opacity = opacity;
              });
            }

            setSlideContentElementsCSSAnimation() {
              const START_RATIO_RANGE = 0.6;

              this.sliderItemsContentElements.forEach((contentElements, contentIndex) => {
                if (!contentElements) return;

                contentElements.forEach((item, index) => {
                  if (this.slidePositionRatio[contentIndex] > START_RATIO_RANGE * -1 && this.slidePositionRatio[contentIndex] < START_RATIO_RANGE) {
                    item.dataset.contentElementIndex = index;
                    item.classList.add('slideshow__content-element--animate');
                  } else if (this.slidePositionRatio[contentIndex] === 1 || this.slidePositionRatio[contentIndex] === -1) {
                    item.classList.remove('slideshow__content-element--animate');
                  }
                });
              });
            }



            preloadImages() {
              this.sliderItemsImgs.forEach((item, index) => {
                if (!item || this.slidePositionFullPercent[index] > 100 || this.slidePositionFullPercent[index] < -100)
                  return;

                item.forEach(element => element.setAttribute('loading', 'eager'));
              });
            }

            applyAnimationToAnnouncementBar(button = 'next') {
              if (!this.announcementBarSlider) return;

              const itemsCount = this.sliderItems.length;
              const increment = button === 'next' ? 1 : -1;

              const currentIndex = this.currentPage;
              let nextIndex = (currentIndex + increment) % itemsCount;
              nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

              const nextSlide = this.sliderItems[nextIndex];
              const currentSlide = this.sliderItems[currentIndex];

              const animationClassIn = 'announcement-bar-slider--fade-in';
              const animationClassOut = 'announcement-bar-slider--fade-out';

              const isFirstSlide = currentIndex === 0;
              const isLastSlide = currentIndex === itemsCount - 1;

              const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
              const direction = shouldMoveNext ? 'next' : 'previous';

              currentSlide.classList.add(`${animationClassOut}-${direction}`);
              nextSlide.classList.add(`${animationClassIn}-${direction}`);

              setTimeout(() => {
                currentSlide.classList.remove(`${animationClassOut}-${direction}`);
                nextSlide.classList.remove(`${animationClassIn}-${direction}`);
              }, this.announcerBarAnimationDelay * 2);
            }

            linkToSlide(event) {
              event.preventDefault();


              this.slideScrollPosition = getLogicalScrollLeft(this.slider) +
                this.sliderFirstItemNode.clientWidth *
                (this.sliderControlLinksArray.indexOf(event.currentTarget) - this.currentPage);
              this.setSlidePosition(this.slideScrollPosition);
            }
          }

          customElements.define('slideshow-component', SlideshowComponent);
        }
      });
    }, ['component-slider', 'component-slideshow']);
  });
});